import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class WarehouseLocalizationContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeDeleted!: boolean;
}
